<app-base-modal [title]="session.device">
  <div class="modal__details">
    <div class="modal__row">
      @for (item of getDisplayedItems(); track item.titleKey) {
        <div class="modal__cell">
          <p class="modal__title">
            {{ 'user-profile.activeSessions.details.' + item.titleKey | translate }}
          </p>
          <p class="modal__description">
            @if (item.isCurrent) {
              {{ 'user-profile.activeSessions.currentSession' | translate }}
            } @else {
              {{ item.description }}
            }
          </p>
        </div>
      }
    </div>
  </div>

  <app-modal-controls
    [terminateDisabledCondition]="session.isCurrent"
    (onSecondaryAction)="close()"
    (onPrimaryAction)="terminate()"
    secondaryActionTextKey="user-profile.activeSessions.termination.cancel"
    primaryActionTextKey="user-profile.activeSessions.termination.terminate"
  />
</app-base-modal>
